import { Col, Row } from 'react-bootstrap';
import React, { useEffect, useState } from 'react';

import Img from 'gatsby-image';
import ReactMarkdown from 'react-markdown';
import SEO from '../../components/seo';
import SidePhoto from '../../components/SidePhoto';
import TrailTitle from '../../components/TrailTitle';
import { graphql } from 'gatsby';

const SupportingPage = ({ data, location }) => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    setOpen((o) => !o);

    return () => {
      setOpen((o) => !o);
    };
  }, []);

  return (
    <>
      <SEO title='Layanan Penunjang' pathname='/services/supporting' />
      {data.support.cover.value && <Img fluid={data.support.cover.value.childImageSharp.fluid} />}
      <Row
        css={{
          minHeight: '75vh',
          backgroundImage: `url(${data.bg.childImageSharp.fixed.src})`,
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'top right',
        }}
        className='pt-5'>
        <Col
          sm={'5'}
          className='d-flex flex-column align-items-center align-content-center'
          css={{ justifyContent: 'space-between' }}>
          <TrailTitle open={open} className='pb-2 mb-5'>
            <div>Layanan</div>
            <div>Penunjang</div>
          </TrailTitle>
        </Col>
        <Col className='d-flex flex-column align-items-center align-content-center pl-3 pr-3 pt-1'>
          <Content
            html={data.support.descriptionHtml}
            fallback={data.support.description.value}
          />
          {data?.itemPenunjang?.edges.map(({ node: { title, description, asset } }, idx) => (
            <div key={idx} className='my-3'>
              <h5 className="font-weight-bold">{title.value}</h5>
              {asset?.value && <Img fluid={asset?.value?.childImageSharp?.fluid} className={'my-2'} />}
              <ReactMarkdown source={description.value} escapeHtml={false} />
            </div>
          ))}
        </Col>
      </Row>
    </>
  );
};

export const query = graphql`
  {
    support: cockpitServices(cockpitId: { eq: "6a4b2f7f38666171bd000226" }) {
      description {
        type
        value
      }
      descriptionHtml
      cover: cover_photo {
        type
        value {
          childImageSharp {
            fluid(maxWidth: 1920, toFormat: WEBP) {
              ...GatsbyImageSharpFluid_withWebp
            }
          }
        }
      }
      side: other_photos {
        value {
          childImageSharp {
            fluid(toFormat: WEBP) {
              ...GatsbyImageSharpFluid_withWebp
            }
          }
        }
      }
    }
    itemPenunjang: allCockpitItemPenunjang {
      edges {
        node {
          id
          title {
            value
          }
          asset {
            value {
              childImageSharp {
                fluid(toFormat: WEBP) {
                  ...GatsbyImageSharpFluid_withWebp
                }
              }
            }
          }
          description {
            value
          }
        }
      }
    }
    bg: file(name: { eq: "bg-ring" }) {
      childImageSharp {
        fixed(toFormat: WEBP) {
          ...GatsbyImageSharpFixed_withWebp
        }
      }
    }
  }
`;

const Content = ({ html, fallback }) => {
  // `descriptionHtml` sudah diproses saat build oleh gatsby-node.js:
  // gambar diunduh & di-host lokal (same-origin), plus kelas img-fluid.
  // `fallback` dipakai jika resolver build gagal menghasilkan HTML.
  const markup =
    html || (fallback || "").replace(/<img /g, '<img class="img-fluid" ');

  return (
    <div
      className="content-wrapper"
      dangerouslySetInnerHTML={{ __html: markup }}
    />
  );
};

export default SupportingPage;